import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
// import { ReportesRepository } from 'src/app/reporte-ventas/domain/reportes.repository';
// import { ReporteVentasIRequest } from 'src/app/reporte-ventas/domain/request/reporte-ventas-request';
import { SharedModule } from 'src/app/shared/shared.module';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { getMonth } from 'date-fns';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ReportesRepository } from 'src/app/repositorio/reportes.repository';
import { ReporteVentasIRequest } from '../../domain/reporte-ventas.request';

@Component({
    selector: 'app-reporte-performance-budget',
    standalone: true,
    imports: [
        CommonModule,
        SharedModule
    ],
    templateUrl: './reporte-performance-budget.component.html',
    styleUrl: './reporte-performance-budget.component.css'
})
export class ReportePerformanceBudgetComponent {

  constructor(
    // private readonly proforma: ProformaRepository,
    // private readonly comisiones: ComisionesRepository,
    private readonly reportes: ReportesRepository,
    // private readonly util: UtilService,
    // private _liveAnnouncer: LiveAnnouncer
  ) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.inicializarFormulario()
  }
  meses: any[] = [
    { codigo: '01', nombre: 'ENERO' },
    { codigo: '02', nombre: 'FEBRERO' },
    { codigo: '03', nombre: 'MARZO' },
    { codigo: '04', nombre: 'ABRIL' },
    { codigo: '05', nombre: 'MAYO' },
    { codigo: '06', nombre: 'JUNIO' },
    { codigo: '07', nombre: 'JULIO' },
    { codigo: '08', nombre: 'AGOSTO' },
    { codigo: '09', nombre: 'SEPTIEMBRE' },
    { codigo: '10', nombre: 'OCTUBRE' },
    { codigo: '11', nombre: 'NOVIEMBRE' },
    { codigo: '12', nombre: 'DICIEMBRE' },
  ]

  group: FormGroup
  inicializarFormulario() {

    this.group = new FormGroup({
      desde: new FormControl(new Date(new Date().getFullYear(), new Date().getMonth(), 1), null),
      hasta: new FormControl(new Date(), null),
      ejecutivo: new FormControl(null, null),
      cliente: new FormControl([], null),
      pod: new FormControl([], null),
      pol: new FormControl([], null),
      etd: new FormControl([], null),
      bkg: new FormControl([], null),
      ov: new FormControl([], null),
      service: new FormControl([], null),
      nave: new FormControl([], null),
      ejecutivos: new FormControl([], null),
      linea: new FormControl([], null),
    })
  }


  dataReporteLinea: any[] = []
  dataReporteLinea2: any[] = []
  TeuMesLineas: any[] = []
  TeuMesTotales: any[] = []
  TeuNumeroSemana: any[] = []
  TeuCantidadSemana: any[] = []
  async GenerarReportePerformanceBudget() {
    this.TeuNumeroSemana = []
    this.TeuCantidadSemana = []
    this.TeuMesLineas = []
    this.TeuMesTotales = []

    const values = this.group.value
    // this.dataReporteSeguimiento = []
    const request = <ReporteVentasIRequest>{}
    request.ejecutivo = []
    request.mes = 0
    request.cliente = []
    request.pol = []
    request.etd = []
    request.linea = []
    request.bkg = []
    request.servcontract = []//values.service || ''
    request.ov = []//values.ov || ''
    request.nave = values.nave || ''
    request.pod = []
    request.tipo = '001'

    this.reportes.ListaReporteVentasIII(request).subscribe(response => {
      this.dataReporteLinea = response.datos.result
    })
    request.tipo = '002'
    this.reportes.ListaReporteVentasIII(request).subscribe(response => {
      this.dataReporteLinea2 = response.datos.result
    })

    function generarColorPastel() {
      const r = Math.floor((Math.random() * 127) + 127);
      const g = Math.floor((Math.random() * 127) + 127);
      const b = Math.floor((Math.random() * 127) + 127);
      return `rgba(${r}, ${g}, ${b}, 0.5)`;
    }


    request.tipo = '001'
    try {
      const response = await this.reportes.ReporteVentasGraficos(request).toPromise();

      let fila = 0
      let colores = []
      // for (let index = 0; index < response.datos.result.length; index++) {
      //   colores.push(generarColorPastel())
      // }

      colores = ['rgb(237, 227, 28, 0.5)', 'rgb(237, 88, 28, 0.5)', 'rgb(28, 164, 237, 0.5)']

      response.datos.result.forEach(r => {

        const item = { linea: r.tipo, data: [r.enero, r.febrero, r.marzo, r.abril, r.mayo, r.junio, r.julio, r.agosto, r.septiembre, r.octubre, r.noviembre, r.diciembre], color: colores[fila] }
        this.TeuMesLineas.push(item)
        fila++
      })

    } catch (error) {
      this.TeuMesLineas = []
    }

    request.tipo = '002'

    try {
      const response = await this.reportes.ReporteVentasGraficos(request).toPromise();
      response.datos.result.forEach(r => {
        this.TeuMesTotales = [r.enero || 0, r.febrero || 0, r.marzo || 0, r.abril || 0, r.mayo || 0, r.junio || 0, r.julio || 0, r.agosto || 0, r.septiembre || 0, r.octubre || 0, r.noviembre || 0, r.diciembre || 0]
      })
    } catch (error) {
      this.TeuMesTotales = []
    }

    request.tipo = '003'
    try {
      const response = await this.reportes.ReporteVentasGraficos(request).toPromise();
      response.datos.result.forEach(r => {
        this.TeuNumeroSemana.push("SEMANA " + (r.tipo).trim())
        this.TeuCantidadSemana.push(r.febrero)
      })
    } catch (error) {
      this.TeuNumeroSemana = []
      this.TeuCantidadSemana = []
    }


    // this.chartVentaTeuLinea.destroy()
    this.graficoTeuMesLinea()
    this.graficoTeuMesTotales()
    this.graficoTeuSemanal()


  }

  //GRAFICOS
  chartVentaTeuLinea: any
  graficoTeuMesLinea() {
    const mes = getMonth(new Date())

    const mesesx = []

    for (let index = 0; index <= mes; index++) {
      mesesx.push(this.meses[index].nombre)

    }


    let pc = true;

    const screenWidth = window.innerWidth;

    if (screenWidth <= 768) {
      pc = false;
    } else {
      pc = true;
    }
    let datasets = []
    if (this.TeuMesLineas.length > 0) {
      datasets = this.TeuMesLineas.map(soporte => ({
        label: "TEU " + soporte.linea,
        data: soporte.data,
        barPercentage: 1,
        borderRadius: 5,
        borderColor: soporte.color,
        tension: 0.4,
        backgroundColor: soporte.color,
        datalabels: {
          color: 'black',
          font: {
            weight: 'bold',
            size: 12
          },
          display: function (context) {
            return context.dataset.data[context.dataIndex] !== 0;
          }
        }
      }));
    } else {
      datasets = [{
        label: "LINEA",
        data: [{}],
        barPercentage: 1,
        borderRadius: 5,
        borderColor: 'rgb(208, 17, 17, 0.5)',
        tension: 0.4,
        backgroundColor: 'rgb(208, 17, 17, 0.5)',
        datalabels: {
          color: 'black',
          font: {
            weight: 'bold',
            size: 12
          },
        }
      }];
    }



    this.chartVentaTeuLinea = new Chart('chartVentaTeuLinea', {
      type: 'line',
      data: {
        xLabels: mesesx,
        datasets: datasets,
      },
      plugins: [ChartDataLabels],
      options: {
        scales: {
          x: {
            ticks: {
              font: {
                size: 9,
                weight: '500'
              },
              color: 'black'

            },
          },
        },
        aspectRatio: 3 / 1.5,
        responsive: true,
        interaction: {
          mode: 'point',
          intersect: false,
        },
        plugins: {
          filler: {
            propagate: false
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                size: pc == true ? 8 : 6,
                weight: '500'
              },
              color: 'black',
            },
          },
          datalabels: {
            anchor: 'end',
            formatter: function (value, context) {
              const options = {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                useGrouping: true,
                style: 'decimal'
              };
              const formattedValue = value.toLocaleString('es-PE');
              return formattedValue;
            },
          },

        },
        elements: {
          line: {
            fill: true,
            tension: 0.4,
            borderWidth: 0.1,
          },
          point: {
            hoverRadius: 15,
          },
        }
      }
    });
  }

  chartVentaTeuMensual: any = []
  graficoTeuMesTotales() {
    const mes = getMonth(new Date())

    const mesesx = []

    for (let index = 0; index <= mes; index++) {
      mesesx.push(this.meses[index].nombre)

    }
    let pc = true;

    const screenWidth = window.innerWidth;

    if (screenWidth <= 768) {
      pc = false;
    } else {
      pc = true;
    }

    this.chartVentaTeuMensual = new Chart('chartVentaTeuMensual', {
      type: 'bar',
      data: {
        xLabels: mesesx,
        datasets: [
          {
            label: 'TOTAL',
            data: this.TeuMesTotales,
            barPercentage: 1,
            borderRadius: 5,
            borderColor: 'rgb(17, 106, 227, 0.5)',
            tension: 0.4,
            backgroundColor: 'rgb(17, 106, 227, 0.5)',
            datalabels: {
              color: 'black',
              font: {
                weight: 'bold',
                size: 10
              },
            }
          },
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        scales: {
          x: {
            ticks: {
              font: {
                size: 9,
                weight: '500'
              },
              color: 'black'

            }
          }
        },
        aspectRatio: 3 / 1.5,
        responsive: true,
        interaction: {
          mode: 'point',
          intersect: false,
        },
        plugins: {
          filler: {
            propagate: false
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                size: pc == true ? 8 : 6,
                weight: '500'
              },
              color: 'black',
            },
          },
          datalabels: {
            anchor: 'end',
            formatter: function (value, context) {
              const options = {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                useGrouping: true,
                style: 'decimal'
              };
              const formattedValue = value.toLocaleString('es-PE');
              return formattedValue;
            },
          },

        },
        elements: {
          line: {
            fill: false,
            tension: 0.4,
            borderWidth: 0.1,
          },
          point: {
            hoverRadius: 15,
          },
        }
      }
    });
  }

  chartVentaTeuSemanal: any = []
  graficoTeuSemanal() {
    const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']
    let pc = true;

    const screenWidth = window.innerWidth;

    if (screenWidth <= 768) {
      pc = false;
    } else {
      pc = true;
    }

    this.chartVentaTeuSemanal = new Chart('chartVentaTeuSemanal', {
      type: 'bar',
      data: {
        xLabels: this.TeuNumeroSemana,
        datasets: [
          {
            label: 'TOTAL',
            data: this.TeuCantidadSemana,
            barPercentage: 1,
            borderRadius: 5,
            borderColor: 'rgb(73, 161, 183, 0.5)',
            tension: 0.4,
            backgroundColor: 'rgb(73, 161, 183, 0.5)',
            datalabels: {
              color: 'black',
              font: {
                weight: 'bold',
                size: 10
              },
              display: function (context) {
                return context.dataset.data[context.dataIndex] !== 0;
              },
            }
          }
        ],

      },
      plugins: [ChartDataLabels],
      options: {
        scales: {
          x: {
            ticks: {
              font: {
                size: 9,
                weight: '500'
              },
              color: 'black'

            },
            stacked: true,
          },
          y: {
            stacked: true,
          }
        },
        aspectRatio: 6 / 1.5,
        responsive: true,
        interaction: {
          mode: 'point',
          intersect: false,
        },
        plugins: {
          filler: {
            propagate: false
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                size: pc == true ? 8 : 6,
                weight: '500'
              },
              color: 'black',
            },
          },
          datalabels: {
            anchor: 'end',
            formatter: function (value, context) {
              const options = {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                useGrouping: true,
                style: 'decimal'
              };
              const formattedValue = value.toLocaleString('es-PE');
              return formattedValue;
            },
          },

        },
        elements: {
          line: {
            fill: false,
            tension: 0.4,
            borderWidth: 0.1,
          },
          point: {
            hoverRadius: 15,
          },
        }
      }
    });
  }

  getTotalCost(columnName: string, arr: any): string {
    let total = 0
    if (arr != undefined) {
      const columnData = (arr.map(row => this.parseNumber(row[columnName] == null ? '0' : row[columnName].toString())));
      total = columnData.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    }

    if (columnName == 'porcentaje') {
      return (total).toFixed(0);
    } else {
      return total.toLocaleString('es-PE');
    }
  }

  parseNumber(numberString: string): number {
    let sanitizedString
    if (numberString != null) {
      const formattedString = numberString.replace(',', '&');
      sanitizedString = formattedString.replace('&', '');
    }
    return parseFloat(sanitizedString);
  }
}
